jQuery(document).ready(function ($) {
	var windowWidth = $(window).width();

	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (
			links[i].hostname !== window.location.hostname &&
			!links[i].classList.contains('icon--account')
		) {
			links[i].target = '_blank';
		}
	}

	/******************************************
    Header Search
  ******************************************/

	// Show desktop search on click and focus on input
	$('.icon--search').on('click', function (e) {
		e.preventDefault();

		$('.desktop-search').fadeIn('fast', '', function () {
			$('body').addClass('search-open');
			$('.desktop-search input').focus();
		});
	});

	// Close desktop search if click outside
	$('body').on('click', function (e) {
		var desktopSearch = $('.desktop-search');

		if (
			!desktopSearch.is(e.target) &&
			desktopSearch.has(e.target).length === 0 &&
			$('body').hasClass('search-open')
		) {
			desktopSearch.fadeOut('fast', '', function () {
				$('body').removeClass('search-open');
				$('.icon--search').focus();
				$('#boost-sd__search-widget-init-wrapper').addClass(
					'boost-sd__g-hide'
				);
			});
		}
	});

	/******************************************
    Mobile Menu
  ******************************************/

	// Trigger mobile menu display
	$('.header__mobile-trigger button').on('click', function () {
		$(this).toggleClass('is-active');

		$('.mobile-menu').fadeToggle('fast', '', function () {
			$('html').toggleClass('mobile-menu-open');
		});
	});

	// Panel Navigation
	// Hide / Show panels on mobile menu
	$('.mobile-menu .top-level.has-children a').on('click', function (e) {
		e.preventDefault();
		var dataTitle = $(this).attr('data-title');
		$('.mobile-menu__front').fadeOut(170, function () {
			$('.mobile-menu__back[data-title="' + dataTitle + '"]').fadeIn(170);
		});
	});

	$('.mobile-menu .sub__heading .back').on('click', function () {
		$('.mobile-menu__back').fadeOut(170, function () {
			setTimeout(function () {
				$('.mobile-menu__front').fadeIn(220);
			}, 150);
		});
	});

	/******************************************
   Quick Buy Modal
  ******************************************/
	$('.card--product .btn--quick-buy').on('click', function () {
		var productHandle = $(this).attr('data-handle');
		var modalID = $(this).attr('data-id');
		var noVars = false;

		if ($(this).hasClass('no-variants')) {
			noVars = true;
		}
		fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
			.then((response) => response.json())
			.then((product) => quickBuyData(product, modalID, noVars));
	});

	$('body').on(
		'click',
		'.boost-sd__button--select-option:not([aria-label="Add to cart"])',
		function (e) {
			var productHandle = $(this).attr('data-handle');
			// var modalID = $(this).attr('data-id');
			var noVars = false;

			if ($(this).hasClass('no-variants')) {
				noVars = true;
			}
			fetch(
				window.Shopify.routes.root + 'products/' + productHandle + '.js'
			)
				.then((response) => response.json())
				.then((product) =>
					quickBuyData(product, 'quick-view_collection', noVars)
				);
		}
	);

	/******************************************
   Product Card Swatch Images
  ******************************************/
	$('.card__swatches .swatch').on('click', function () {
		var dataImage = $(this).attr('data-image');
		var dataImageSrcset = $(this).attr('data-image-srcset');
		var dataColor = $(this).attr('data-color');
		// console.log(dataImage);
		if (dataImage.indexOf('no-image') === -1) {
			var newImage =
				'<img src="' +
				dataImage +
				'" srcset="' +
				dataImageSrcset +
				'" class="image--swatch image" data-color="' +
				dataColor +
				'"/>';

			$(this).closest('.card').find('.card__image a').append(newImage);
			$(this).closest('.card').find('.image--swatch').show();

			$(this)
				.closest('.card')
				.find('.swatch')
				.removeClass('swatch--active');

			$(this).addClass('swatch--active');
		}
	});

	$('.card__swatches .swatch').on('mouseleave', function () {
		$(this).closest('.card').find('.image--swatch').hide();

		$(this).closest('.card').find('.image--swatch').remove();

		$(this).removeClass('swatch--active');
	});

	/******************************************
    Modals
  ******************************************/

	// Launch the modal
	$('body').on('click', '.btn--modal', function (e) {
		e.preventDefault();
		var modalID = '#' + $(this).attr('data-modal');
		// console.log(modalID);

		if ($(this)[0].hasAttribute('data-video-yt')) {
			var videoID = $(this).attr('data-video-yt');
			$(modalID)
				.find('.modal__inner')
				.append(
					'<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' +
						videoID +
						'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'
				);
		}

		if ($(this)[0].hasAttribute('data-video-vimeo')) {
			var videoID = $(this).attr('data-video-vimeo');
			$(modalID)
				.find('.modal__inner')
				.append(
					'<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' +
						videoID +
						'"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>'
				);
		}

		$(modalID).fadeIn('fast');
	});

	// Close the modal
	$('.modal--close, .modal__bg').on('click', function (e) {
		closeModal($(this));
	});

	/******************************************
  Quick View Modal from Product Card ( Process ATC / Variant Options Select )
  ******************************************/

	$('body').on('change', '.modal--quick .option__wrap select', function () {
		quickViewVariant();
	});

	$('body').on('click', '.modal--quick .option__wrap button', function () {
		quickViewVariant();
	});

	/******************************************
  Quick View Modal Add to Cart
  ******************************************/
	$('body').on('click', '.modal--quick .btn--atc', function () {
		var id = $(this)
			.closest('.modal__inner')
			.find('#variantSelector')
			.find(':selected')
			.attr('data-variant_id');
		var qty = $(this).closest('.modal__inner').find('.qty-val').val();

		CartJS.addItem(
			parseInt(id),
			qty,
			{},
			{
				success: function (data, textStatus, jqXHR) {
					jQuery.getJSON('/cart.js', function (cart) {
						closeModal($('.modal--quick .modal__inner'));
						refreshMiniCart(cart);
					});
				},
				error: function (jqXHR, textStatus, errorThrown) {
					//error state
					console.log('Error: ' + jqXHR + '!');
				},
			}
		);
	});
});

function closeModal(object) {
	object.closest('.modal').fadeOut('fast', function () {
		$('.modal__inner .iframe-wrap').remove();
		$('.modal--quick .modal__inner').empty();
	});
}

function quickViewVariant() {
	var matchStringArray = [];
	if ($('[data-option="sm-rc-option1-selector"]').length) {
		if (
			$('[data-option="sm-rc-option1-selector"]').hasClass(
				'option__wrap--button'
			)
		) {
			matchStringArray.push(
				$('[data-option="sm-rc-option1-selector"]')
					.find('button.active')
					.attr('data-val')
			);
		} else {
			matchStringArray.push(
				$('[data-option="sm-rc-option1-selector"]').find('select').val()
			);
		}
	}
	if ($('[data-option="sm-rc-option2-selector"]').length) {
		if (
			$('[data-option="sm-rc-option2-selector"]').hasClass(
				'option__wrap--button'
			)
		) {
			matchStringArray.push(
				$('[data-option="sm-rc-option2-selector"]')
					.find('button.active')
					.attr('data-val')
			);
		} else {
			matchStringArray.push(
				$('[data-option="sm-rc-option2-selector"]').find('select').val()
			);
		}
	}
	if ($('[data-option="sm-rc-option3-selector"]').length) {
		if (
			$('[data-option="sm-rc-option3-selector"]').hasClass(
				'option__wrap--button'
			)
		) {
			matchStringArray.push(
				$('[data-option="sm-rc-option3-selector"]')
					.find('button.active')
					.attr('data-val')
			);
		} else {
			matchStringArray.push(
				$('[sm-rc-option3-selector]').find('select').val()
			);
		}
	}

	if (matchStringArray.length) {
		matchString = matchStringArray.join(' / ');
	} else {
		matchString = false;
	}

	// Deal with the ATC button
	if (
		$('#variantSelector option[value="' + matchString + '"]').attr(
			'data-available'
		) == 'true'
	) {
		$('[sm-rc-add-to-cart]').prop('disabled', false);
		$('.oos-text').hide();
		$('.is-text').show();
	} else {
		$('[sm-rc-add-to-cart]').prop('disabled', true);
		$('.oos-text').show();
		$('.is-text').hide();
	}

	// Change the pricing
	var priceSale = $(
		'#variantSelector option[value="' + matchString + '"]'
	).attr('data-price');

	var priceOrig = $(
		'#variantSelector option[value="' + matchString + '"]'
	).attr('data-compare-price');

	if (priceSale != priceOrig && priceOrig != '$0.00') {
		$('.modal--quick .price--sale').text(priceSale);
		$('.modal--quick .price--orig').text(priceOrig);
	} else {
		$('.modal--quick .price--sale').text(priceSale);
		$('.modal--quick .price--orig').text('');
	}

	// Change the variant select
	$('#variantSelector').val(matchString).change();
}
